import { AlarmClock, Building, Plane, User, UserMinus } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export default function ReportsDashboard() {
  const navigate = useNavigate();

  const otherReportTypes = [
    {
      id: 1,
      title: "Attendance Report",
      description: "Complete attendance history of all employees",
      icon: <User size={35} stroke="#302867" />,
      path: "/reports/attendance",
    },
    {
      id: 2,
      title: "Leave Report",
      description: "View all employees currently on leave",
      icon: <Plane size={35} stroke="#302867" />,
      path: "/reports/leave",
    },
    {
      id: 3,
      title: "Late Comers Report",
      description: "Detailed report of all late entries",
      icon: <AlarmClock size={35} stroke="#302867" />,
      path: "/reports/late",
    },
    {
      id: 4,
      title: "Early Going Report",
      description: "Breakdown of employees who left early",
      icon: <UserMinus size={35} stroke="#302867" />,
      path: "/reports/early",
    },
    {
      id: 5,
      title: "Consolidated Report",
      description: "Consolidated audit report for each department",
      icon: <Building size={35} stroke="#302867" />,
      path: "/reports/consolidated",
      consolidated: true,
    },
  ];

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row">
        <div className="col-12">
          <div className="reports-container">
            <div className="d-flex flex-column">
              <h5 className="fs-4 fw-semibold m-0">
                Generate & Download Reports
              </h5>
              <span className="text-muted fs-6">
                Select a report type and date range to download a customized
                Excel report.
              </span>
            </div>
            <div className="row mt-4 g-3">
              {otherReportTypes.map((r) => (
                <div key={r.id} className="col-lg-4 col-md-6 col-sm-12">
                  <Link
                    to={r.path}
                    state={{ isConsolidated: !!r.consolidated }}
                    className="text-decoration-none"
                  >
                    <div className="card p-3 h-100">
                      <div className="d-flex align-items-center gap-3">
                        {r.icon}
                        <div>
                          <h6 className="mb-0">{r.title}</h6>
                          <small className="text-muted">{r.description}</small>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
